import { render, staticRenderFns } from "./TrxCreditOut.vue?vue&type=template&id=1a74d4e9"
import script from "./TrxCreditOut.vue?vue&type=script&lang=js"
export * from "./TrxCreditOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports